<template>
    <section class="onboarding-wrapper onboarding-de">
        <div class="onboarding-header">
            <div class="container">
                <a href="#" class="progress-back" @click.prevent="goBack" v-if="currentTab != 'thanks'">
                    <span class="material-symbols-rounded">west</span>
                    <span class="progress-back-text">{{ __('Back') }}</span>
                </a>

                <div class="site-header-contact">
                    <div>
                        <figure>
                            <span class="material-symbols-rounded">phone</span>   
                        </figure>

                        <div class="contact-text">
                            <a href="tel:0158 88 72 57 51">0158 88 72 57 51</a>
                            <div  v-if="isAvailable" class="online">
                                <span></span>
                                <p>Jetzt erreichbar</p>
                            </div>
                            <small v-else>Mo-Fr, 9:00-17:00 Uhr</small>
                        </div>
                    </div>

                    <div>
                        <figure>
                            <span class="material-symbols-rounded">mail</span>                                                                  
                        </figure>

                        <div class="contact-text">
                            <a href="mailto:kontakt@vitadio.de">kontakt@vitadio.de</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <onboarding-question-welcome v-if="showTab('welcome')" @clicked="setTab"></onboarding-question-welcome>
            <onboarding-question-index v-if="showTab('index')" @clicked="setTab"></onboarding-question-index>
            <onboarding-question-diabetes v-if="showTab('none')" @clicked="setTab"></onboarding-question-diabetes>
            <onboarding-question-diabetes-not-eligible v-if="showTab('not-eligible')" @clicked="setTab"></onboarding-question-diabetes-not-eligible>
            <onboarding-question-app v-if="showTab('app')" @clicked="setTab"></onboarding-question-app>
            <onboarding-question-diagnose v-if="showTab('diagnose')" @clicked="setTab"></onboarding-question-diagnose>
            <onboarding-question-info v-if="showTab('info')" @clicked="setTab"></onboarding-question-info>
            <onboarding-question-email v-if="showTab('email')" @clicked="setTab"></onboarding-question-email>
            <onboarding-question-call v-if="showTab('call')" @clicked="setTab"></onboarding-question-call>
            <onboarding-question-download-app v-if="showTab('download')" @clicked="setTab"></onboarding-question-download-app>
            <onboarding-question-thank-you v-if="showTab('thanks')" @clicked="setTab"></onboarding-question-thank-you>
        </div>
    </section>
</template>

<script>
import OnboardingQuestionIndex from './OnboardingQuestionIndex'
import OnboardingQuestionDiabetes from './OnboardingQuestionDiabetes'
import OnboardingQuestionDiabetesNotEligible from './OnboardingQuestionDiabetesNotEligible'
import OnboardingQuestionApp from './OnboardingQuestionApp'
import OnboardingQuestionDiagnose from './OnboardingQuestionDiagnose'
import OnboardingQuestionInfo from './OnboardingQuestionInfo'
import OnboardingQuestionEmail from './OnboardingQuestionEmail'
import OnboardingQuestionCall from './OnboardingQuestionCall'
import OnboardingQuestionDownloadApp from './OnboardingQuestionDownloadApp'
import OnboardingQuestionThankYou from './OnboardingQuestionThankYou'
import OnboardingQuestionWelcome from './OnboardingQuestionWelcome'

export default {
    components: { 
        OnboardingQuestionIndex,
        OnboardingQuestionDiabetes,
        OnboardingQuestionDiabetesNotEligible,
        OnboardingQuestionApp,
        OnboardingQuestionDiagnose,
        OnboardingQuestionInfo,
        OnboardingQuestionEmail,
        OnboardingQuestionCall,
        OnboardingQuestionDownloadApp,
        OnboardingQuestionThankYou,
        OnboardingQuestionWelcome
    },
    data() {
        return {
            currentTab: 'welcome',
            eligibleRoute: false,
            learntAboutVitadioFrom: null
        }
    },

    watch: {

    },

    computed: {
        isAvailable() {
            const now = new Date();
            const day = now.getDay(); // Sunday - Saturday : 0 - 6
            const hour = now.getHours();
            const minute = now.getMinutes();

            const start = 9 * 60; // 9:00 AM in minutes
            const end = 17 * 60; // 5:00 PM in minutes
            const currentTime = hour * 60 + minute;

            // Check if it's a weekday and if the time is between 9:00 AM and 5:00 PM
            return (day !== 0 && day !== 6) && (currentTime > start && currentTime < end);
        }
    },

    methods: {
        setTab(tab) {     
            $('html, body').animate({scrollTop: $("#page").offset().top}, 0)

            this.currentTab = tab

            if(this.currentTab === 'index') {
                this.eligibleRoute = false
            }

            if(this.currentTab === 'none') {
                this.eligibleRoute = true
            }
        },
        showTab(tab) {
            if(tab === this.currentTab) {
                return true
            }
        },
        goBack() {
            if(this.currentTab === 'welcome') {
                window.location.href = '/'
            }

            if(this.currentTab === 'index') {
                this.setTab('welcome')
            }

            if(this.currentTab === 'none') {
                this.setTab('index')
            }

            if(this.currentTab === 'not-eligible') {
                this.setTab('none')
            }

            if(this.currentTab === 'diagnose') {
                this.setTab('none')
            }

            if(this.currentTab === 'app') {
                if(this.eligibleRoute) {
                    this.setTab('diagnose')
                } else {
                    this.setTab('index')
                }
            }

            if(this.currentTab === 'info') {
                this.setTab('diagnose')
            }

            if(this.currentTab === 'email') {
                this.setTab('thanks')
            }

            if(this.currentTab === 'call') {
                this.setTab('email')
            }

            if(this.currentTab === 'download') {
                this.setTab('index')
            }
        }
    }
}
</script>